import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export interface ColumnGroupOption {
    paymentViewId: number;
    paymentViewText: string;
}

export class filterPaymentView_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="column-manager icon i-dropdown-dots">
                <label class="form-label" for="payment-views">Payment View: </label>
                <select id="payment-views" name="payment-views" data-bind="
                    options: paymentViews,
                    optionsText: 'paymentViewText',
                    optionsValue: 'paymentViewId',
                    value: selectedPaymentView,
                    event: { change: onChangeFilterAction }
                    ">
                </select>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return 'filterPaymentView-template';
    }

    protected buildViewModel(): object {
        let huit_neuf_this = this;

        return {
            paymentViews: ko.observableArray([{ paymentViewId: 0, paymentViewText: ''}]),
            selectedPaymentView: ko.observable(0),
            onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); },
            setPaymentViews: function (data, event) { huit_neuf_this.setPaymentViews(data); }
        };
    }

    public onChangeFilterAction(data) {
        this.caller.onChangePaymentView(data.selectedPaymentView());
    }

    protected setPaymentViews(paymentViews){
        this.getTemplateViewModel().paymentViews(paymentViews);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/filterPaymentView_template.ts